/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Publishedlabel1Inputs */

const he_posts_publishedlabel1 = /** @type {(inputs: Posts_Publishedlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פורסם`)
};

const en_posts_publishedlabel1 = /** @type {(inputs: Posts_Publishedlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Posts_Publishedlabel1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const posts_publishedlabel1 = /** @type {((inputs?: Posts_Publishedlabel1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Publishedlabel1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_publishedlabel1(inputs)
	return en_posts_publishedlabel1(inputs)
});
export { posts_publishedlabel1 as "posts_publishedLabel" }